// @flow
import React from 'react';
import classnames from 'classnames';

import { t } from 'Src/i18n';
import { Product } from 'Components/widgets/product/Product';
import { useRouter } from 'Client/router/useRouter';
import ReactAppContext from 'Context/ReactAppContext';
import { createPropsForProduct } from 'Components/widgets/trip-summary/trip-overview/TripOverview';
import { Button } from 'Components/frameworks/button/Button';
import { COLORS } from 'Components/utils/color/colors';
import { useTracking } from 'Tracking/tracking-api/useTracking';

type Props = {|
  suggestion: ResortSuggestion,
  className?: string,
  onClick?: (id: string, name: string) => mixed,
  scrollToBookingEngineEntryPoint?: () => void,
  categoryGA?: string,
|};

export const AlternativeResortThumbnail = (props: Props) => {
  const {
    suggestion,
    className,
    onClick,
    categoryGA = 'resort',
    scrollToBookingEngineEntryPoint,
  } = props;
  const appContext = React.useContext(ReactAppContext);
  const { history } = useRouter<BookingUrlParams, BookingQueryParams>();
  const trackClick = useTracking({
    categoryGA,
    actionGA: 'checkPricesKO',
  });

  const handleClick = () => {
    const { id, name, href } = suggestion.resort;
    onClick
      ? onClick(id, name)
      : history.pushRoute(href).then(() => {
          if (scrollToBookingEngineEntryPoint) {
            scrollToBookingEngineEntryPoint();
          }
        });
  };

  return (
    <div
      data-testid="AlternativeResortThumbnail"
      className={classnames('AlternativeResortThumbnail flex flex-col mr-4', className)}
    >
      <Product
        className="AlternativeProposalsModal-thumbnail"
        {...createPropsForProduct(suggestion.resort, undefined, appContext)}
        hasLazyLoading={false}
        // Allows to avoid to launch the tracking on the arrows of the slider
        onClick={e => {
          if (e.target instanceof HTMLImageElement) {
            handleClick();
            trackClick({ labelGA: 'resort_checkThumbnail' });
          }
        }}
      />
      <Button
        dataTestId="AlernativeResortThumbnailButton"
        className="px-6 my-6 self-center"
        color={COLORS.WHITE}
        colorBg={COLORS.TURQUOISE}
        colorBorder={COLORS.TURQUOISE}
        trackingData={{
          actionGA: 'checkPricesKO',
          labelGA: 'resort_check',
          categoryGA: 'resort',
        }}
        onClick={handleClick}
      >
        {t('booking.counterProposalPopIn.checkPriceLabelResort')}
      </Button>
    </div>
  );
};
